var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useComponents } from '@tencent/dz-elements';
import styles from './index.less';
export var UIInput = function (props) {
    var _a = useComponents(), View = _a.View, Input = _a.Input;
    var error = props.error;
    var type = error ? 'error' : 'common';
    return (React.createElement(View, { className: styles["input-container-" + type], style: { flexShrink: 1 } },
        React.createElement(Input, __assign({}, props))));
};
